import styled from "styled-components";

export const SkillsSectionWrapper = styled.section`
  min-height: 100vh;
`;

export const SkillsHeading = styled.h3`
  font-size: 3rem;
  margin: 2em auto 0.5em auto;
  text-align: center;
  text-decoration: underline;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SkillsClassification = styled.h4`
  text-align: center;
  font-weight: 300;
  font-size: 1.3em;
`;

export const SkillsCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 90%;
  gap: 20px;
  margin: 0 auto 1em auto;
`;

export const SkillWrapper = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 150px;
  padding: 0.5em 0px;
  margin: 1em 0;
  background-color: #fcfcfc;
  box-shadow: 2.6px 5.1px 5.1px hsl(0deg 0% 0% / 0.42);
  transition: 0.4s ease-in-out;
  opacity: 0.9;

  &:hover {
    transform: scale(1.05);
    opacity: 1;
  }
`;

export const SkillImg = styled.img`
  max-width: 100%;
  display: block;
  margin: 0 auto 20px auto;
`;

export const P = styled.p`
  margin-top: 0.5em;
  text-align: center;
  font-weight: 600;
`;
